import {
  NotificationBar,
  NotificationBarTitle,
  NotificationBarSubtitle,
  NotificationBarAction,
} from '@/components/NotificationBar'

export interface RatingsNotificationBarProps {
  onShowRateProDialog: () => unknown
  showRateDialogButtonTestId?: string
  testId?: string
}

export function RatingsNotificationBar({
  onShowRateProDialog,
  showRateDialogButtonTestId,
  testId,
}: RatingsNotificationBarProps) {
  return (
    <NotificationBar testId={testId}>
      <NotificationBarTitle>
        Please rate your experience with us.
      </NotificationBarTitle>
      <NotificationBarSubtitle>
        We appreciate any feedback and reviews.
      </NotificationBarSubtitle>
      <NotificationBarAction
        testId={showRateDialogButtonTestId}
        onClick={onShowRateProDialog}
      >
        Add a review
      </NotificationBarAction>
    </NotificationBar>
  )
}
